/**
 * Event name: 'footer.configuration'
 * Features publish this to control footer appearance.
 */
export interface FooterConfigurationEvent {
	visible?: boolean;
}

export const DEFAULT_FOOTER_CONFIGURATION: Required<FooterConfigurationEvent> = {
	visible: true
};

export const FOOTER_EVENTS = {
	CONFIGURATION: 'footer.configuration'
} as const;
